import { AncDateRangePreset } from '../anc-filter.models';
import { toIso } from './calendar';

function addDays(d: Date, n: number): Date {
    const x = new Date(d);
    x.setDate(d.getDate() + n);
    return x;
}
function startOfMonth(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), 1);
}
function endOfMonth(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

export const DEFAULT_PRESETS: AncDateRangePreset[] = [
    { id: 'today', label: 'Today', range: () => { const t = new Date(); return { start: toIso(t), end: toIso(t) }; } },
    { id: 'yesterday', label: 'Yesterday', range: () => { const y = addDays(new Date(), -1); return { start: toIso(y), end: toIso(y) }; } },
    { id: 'last_7_days', label: 'Last 7 days', range: () => { const t = new Date(); return { start: toIso(addDays(t, -6)), end: toIso(t) }; } },
    { id: 'this_month', label: 'This Month', range: () => { const t = new Date(); return { start: toIso(startOfMonth(t)), end: toIso(endOfMonth(t)) }; } },
    { id: 'last_month', label: 'Last Month', range: () => { const lm = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1); return { start: toIso(startOfMonth(lm)), end: toIso(endOfMonth(lm)) }; } },
];
